export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
// eslint-disable-next-line no-useless-escape
export const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/gm;
export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const numberRegex = /^[0-9]+$/;
export const priceRegex = /^\d+(?:\.\d+)?(?:,\d+(?:\.\d+)?)*$/;
export const FloatingNumber = /^(?![0.]+$)\d+(\.\d{1,2})?$/gm; // possitive
export const decimalregex = /^\d+(\.\d{0,2})?$/; // 0 allow
